import { memoize } from '@exodus/basic-utils';
import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

import type { App, FeaturedApp } from '../../types.js';
import type { Data } from '../initial-state.js';

function hasFeaturedData(app: App): app is FeaturedApp {
  return !!app.featured;
}

const resultFunction = memoize((data: Data) =>
  data.apps.filter((app) => hasFeaturedData(app)),
);

const featuredAppsDefinition = {
  id: 'featuredApps',
  resultFunction,
  dependencies: [
    //
    { selector: 'data' },
  ],
} as const satisfies SelectorDefinition;

export default featuredAppsDefinition;
